import { Button, Input } from "@heroui/react";
import { useState } from "react";
import { BigProfileCreation } from "@/api/businessProfiles";

interface RequisitesFormProps {
  defaults?: Partial<BigProfileCreation>;
  onSubmit: (data: Partial<BigProfileCreation>) => void;
}

export function RequisitesForm({ defaults, onSubmit }: RequisitesFormProps) {
  const [formData, setFormData] = useState({
    req_display_name: defaults?.req_display_name || "",
    kpp: defaults?.kpp || "",
    bank_account: defaults?.bank_account || "",
    bank_name: defaults?.bank_name || "",
    bik: defaults?.bik || "",
    correspondent_account: defaults?.correspondent_account || "",
    phone: defaults?.phone || "",
    email: defaults?.email || "",
    req_owner_name: defaults?.req_owner_name || "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="w-full">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <Input
          label="Название реквизитов"
          placeholder="Введите название реквизитов"
          value={formData.req_display_name}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              req_display_name: e.target.value,
            }))
          }
          isRequired
          variant="bordered"
        />

        <div className="flex flex-col lg:flex-row gap-4">
          <Input
            label="КПП"
            placeholder="Введите КПП"
            value={formData.kpp || ""}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                kpp: e.target.value,
              }))
            }
            isRequired
            variant="bordered"
            className="flex-1"
          />
          <Input
            label="Номер счета"
            placeholder="Введите номер банковского счета"
            value={formData.bank_account}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, bank_account: e.target.value }))
            }
            isRequired
            variant="bordered"
            className="flex-1"
          />
        </div>

        <Input
          label="Название банка"
          placeholder="Введите название банка"
          value={formData.bank_name}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, bank_name: e.target.value }))
          }
          isRequired
          variant="bordered"
        />

        <div className="flex flex-col lg:flex-row gap-4">
          <Input
            label="БИК"
            placeholder="Введите БИК"
            value={formData.bik}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, bik: e.target.value }))
            }
            isRequired
            variant="bordered"
            className="flex-1"
          />
          <Input
            label="Корреспондентский счет"
            placeholder="Введите корреспондентский счет"
            value={formData.correspondent_account}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                correspondent_account: e.target.value,
              }))
            }
            isRequired
            variant="bordered"
            className="flex-1"
          />
        </div>

        <div className="flex flex-col lg:flex-row gap-4">
          <Input
            label="Телефон"
            placeholder="Введите телефон"
            value={formData.phone}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, phone: e.target.value }))
            }
            isRequired
            variant="bordered"
            className="flex-1"
          />
          <Input
            label="Email"
            placeholder="Введите email"
            type="email"
            value={formData.email}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, email: e.target.value }))
            }
            isRequired
            variant="bordered"
            className="flex-1"
          />
        </div>

        <Input
          label="ФИО владельца"
          placeholder="Введите ФИО владельца"
          value={formData.req_owner_name}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, req_owner_name: e.target.value }))
          }
          isRequired
          variant="bordered"
        />

        <div className="flex flex-row gap-2 justify-end">
          <Button
            type="submit"
            className="bg-elastic-500 hover:bg-elastic-600 text-black font-medium">
            Создать бизнес-профиль
          </Button>
        </div>
      </form>
    </div>
  );
}
